/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  CDTransferResponse,
  GetTipiDomandaEsportaParams,
  PostTipiDomandaImportaBody,
  PostTipiDomandaImportaParams,
  WsProblema,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Importa un tipo di domanda
 * @summary Importa un tipo di domanda
 */
export const postTipiDomandaImporta = (
  postTipiDomandaImportaBody: PostTipiDomandaImportaBody,
  params?: PostTipiDomandaImportaParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postTipiDomandaImportaBody.file);

  return apiClientRequest<CDTransferResponse>(
    {
      url: `/framework-cfg-domande/tipi-domanda/importa`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    },
    options,
  );
};

export const getPostTipiDomandaImportaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaImporta>>,
    TError,
    { data: PostTipiDomandaImportaBody; params?: PostTipiDomandaImportaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaImporta>>,
  TError,
  { data: PostTipiDomandaImportaBody; params?: PostTipiDomandaImportaParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaImporta>>,
    { data: PostTipiDomandaImportaBody; params?: PostTipiDomandaImportaParams }
  > = props => {
    const { data, params } = props ?? {};

    return postTipiDomandaImporta(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaImportaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaImporta>>
>;
export type PostTipiDomandaImportaMutationBody = PostTipiDomandaImportaBody;
export type PostTipiDomandaImportaMutationError = ErrorType<unknown>;

/**
 * @summary Importa un tipo di domanda
 */
export const usePostTipiDomandaImporta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaImporta>>,
    TError,
    { data: PostTipiDomandaImportaBody; params?: PostTipiDomandaImportaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaImportaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Esporta un tipo di domanda dato il rispettivo ID in ingresso.
 * @summary Esporta un tipo di domanda
 */
export const getTipiDomandaEsporta = (
  params: GetTipiDomandaEsportaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<unknown>(
    {
      url: `/framework-cfg-domande/tipi-domanda/esporta`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaEsportaQueryKey = (
  params: GetTipiDomandaEsportaParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/esporta`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaEsportaQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaEsporta>>,
  TError = ErrorType<WsProblema>,
>(
  params: GetTipiDomandaEsportaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaEsporta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaEsporta>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaEsportaQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaEsporta>>
  > = ({ signal }) => getTipiDomandaEsporta(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaEsportaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaEsporta>>
>;
export type GetTipiDomandaEsportaQueryError = ErrorType<WsProblema>;

/**
 * @summary Esporta un tipo di domanda
 */
export const useGetTipiDomandaEsporta = <
  TData = Awaited<ReturnType<typeof getTipiDomandaEsporta>>,
  TError = ErrorType<WsProblema>,
>(
  params: GetTipiDomandaEsportaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaEsporta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaEsportaQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
